"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccountIdentifier = void 0;
const sodium = require("libsodium-wrappers");
const bs58check = require("bs58check");
exports.getAccountIdentifier = async (address, network) => {
    const data = [address, network.type];
    if (network.name) {
        data.push(`name:${network.name}`);
    }
    if (network.rpcUrl) {
        data.push(`rpc:${network.rpcUrl}`);
    }
    await sodium.ready;
    const buffer = Buffer.from(sodium.crypto_generichash(10, data.join('-')));
    return bs58check.encode(buffer);
};
//# sourceMappingURL=get-account-identifier.js.map